/* tslint:disable:variable-name adjacent-overload-signatures */
import { GeographicArea } from '../../user/geographicArea';
import { Unit } from '../../user/unit';
import { JurisdictionalAgency } from './jurisdictionalAgency';
import { Collaborator } from './collaborator';
import { User, UserUtilites } from '../../index';
import { Moment } from 'moment';

export class WfdssCase {
  wfdssCaseId: number
  version: number
  name: string
  createdOnDateTime: number 
  modifiedOnDateTime: number
  initialLatitude: number
  initialLongitude: number
  currentPlanningAreaCreatedDate: any
  fireDiscoveryDateTime: number
  incidentSize: number
  estimatedCostToDate: any
  estimatedFinalCost: number
  pooState: string
  currentCalculatedAcres: any
  pooLandownerCategory: string
  geographicArea: GeographicArea
  jurisdictionalAgencyAtPoO: JurisdictionalAgency
  jurisdictionalUnitAtPoO: Unit
  jurisdictionalAgencies: any[]
  collaborators: Collaborator[] = []
  wfdssDecisionStatus: string
  originTimeZone: any
  irwinId: string
  objectId: number
  uniqueFireIdentifier: string
  predSvcsNatCode: any
  hasNatlSignificance: any
  assessmentDue: any
  assessmentPeriod: any
  latestRelativeRiskAssessmentId: any
  latestStrategicAssessmentId: any
  latestStrategicCourseOfActionId: any
  latestOrganizationAssessmentId: any
  irwinIncidentComplexityLevel: any
  publishedDecision: any
  isStrategyMet: boolean | null;
  fundingSpent: any
  fundingApproved: any
  totalIncidentPersonnel: any
  resourceQuantity: any
  containmentDateTime: any
  controlDateTime: any
  fireOutDateTime: any
  fireStrategyDirExtPercent: any
  fireStrategyIndirConfPercent: any
  fireStrategyConfinePercent: any
  fireStrategyFullSuppPercent: any
  fireStrategyMonitorPercent: any
  fireStrategyPointZonePercent: any
  isValid: boolean
  isQuarantined: boolean
  xlatitude: number
  ylongitude: number
  protectingUnitAtPoO:Unit

  // Incident leads seems to be junk but there is a reference in data studio
  // private _incidentLeads: string;
  // set incidentLeads(value) {
  //   this._incidentLeads = value;
  // }
  // get incidentLeads() {
  //   return this.collaborators.filter(collaborator => {
  //     return collaborator.isLead;
  //   }).map(collaborator => {
  //     return `${UserUtilites.getUserFirstNameSpaceLastName(collaborator.user)}`;
  //   }).join(', ');
  // }
}

export class UserIncident {
  incidentName: string
  wfdssDecisionStatus: string
  uniqueFireIdentifier: string
  relativeRiskRating: string
  recommendedOrganization: string
  assessmentDue: Date
  estimatedFinalCost: number
  estimatedCostToDate: number
  pointOfContact: string
  landownerCategory: string
  jurisdictionalUnitName: string
  gacc: string
  multijurisdictional: boolean
  size: number
  strategyDirExt: number
  strategyIndirConf: number
  strategyFull: number
  strategyPointZone: number
  strategyConfine: number
  strategyMonitor: number
  createdOnDateTime: Date
  irwinId: string
  pocUserId: string
  wfdssCaseId: string
  publishedDecision: any;
  isStrategyMet: boolean | null;

}
